import React from 'react';
import { queries } from '../../../graphql/graphql';
import ListContainer from '../../../components/containers/AdminList';

const ListContractors: React.FC = () => {
  return (
    <ListContainer
      prefix="contractor"
      query={queries.contractors.CONTRACTORS}
      inline={true}
      editable={true}
      canCreate={true}
      adminView={true}
    />
  );
};

export default ListContractors;
